import Vue from "vue";

import VueRouter from "vue-router";
import store from "./state/store";

Vue.use(VueRouter);

const requireAuth = (to, from, next) => {
  // console.log(to)
  if (store.getters.isAuth) {
    next();
    return;
  }
  next("/");
  return;
};

const ifAuth = (to, from, next) => {
  // console.log(to)
  if (store.getters.isAuth) {
    next({ name: "admin" });
    return;
  } else {
    next();
    return;
  }
};

export const router = new VueRouter({
  // mode: "history",
  routes: [
    // { path: '/', name:'App', component: () => import("./App.vue") },
    {
      path: "/",
      name: "Login",
      component: () => import("./components/auth/Login"),
      beforeEnter: ifAuth,
    },
    {
      path: "/admin",
      name: "admin",
      component: () => import("./components/layout/master.layout.vue"),
      beforeEnter: requireAuth,
      children: [
        {
          path: "/",
          name: "overview",
          component: () => import("./components/layout/adminOverview.vue"),
        },
        {
          path: "/admin/applicants",
          name: "applicants",
          component: () => import("./components/application/Applicants"),
        },
        {
          path: "/admin/pgcoord/list",
          name: "approvePgcoord",
          component: () => import("./components/approve.pgcoord.vue"),
        },
        {
          path: "/admin/Schedule",
          name: "Schedule",
          component: () => import("./components/payments/schedule.vue"),
        },
        {
          path: "/admin/report",
          name: "report",
          component: () => import("./components/payments/report.vue"),
        },
        {
          path: "/admin/payment/admisson",
          name: "Admission",
          component: () =>
            import("./components/payments/admission.payment.vue"),
        },
        {
          path: "/admin/payment/student",
          name: "Student",
          component: () => import("./components/payments/student.payment.vue"),
        },
        {
          path: "/admin/courses",
          name: "courses",
          component: () => import("./components/academics/CourseManagement.vue"),
        },
        {
          path: "/admin/curriculum",
          name: "curriculum",
          component: () => import("./components/academics/CurriculumManagement.vue"),
        },
        {
          path: "/admin/course-registration",
          name: "courseRegistration",
          component: () => import("./components/academics/CourseRegistration.vue"),
        },
        {
          path: "/admin/course-outstanding",
          name: "courseOutstanding",
          component: () => import("./components/academics/CourseOutstanding.vue"),
        },
        {
          path: "/admin/results",
          name: "resultManagement",
          component: () => import("./components/academics/ResultManagement.vue"),
        },
        {
          path: "/admin/student/profile",
          name: "studprofile",
          component: () => import("./components/Student.profile.vue"),
        },
        {
          path: "/admin/bursary/dashboard",
          name: "bursaryDashboard",
          component: () => import("./components/bursary/BursaryDashboard.vue"),
        },
        {
          path: "/admin/bursary/billing",
          name: "billingManagement",
          component: () => import("./components/bursary/BillingManagement.vue"),
        },
        {
          path: "/admin/bursary/ledger",
          name: "studentLedger",
          component: () => import("./components/bursary/StudentLedger.vue"),
        },
        {
          path: "/admin/bursary/gateway-reports",
          name: "gatewayReports",
          component: () => import("./components/bursary/GatewayReports.vue"),
        },
        {
          path: "/admin/bursary/fee-schedule",
          name: "feeScheduleManagement",
          component: () => import("./components/bursary/FeeScheduleManagement.vue"),
        },
        {
          path: "/admin/bursary/admission-fees",
          name: "admissionFees",
          component: () => import("./components/bursary/AdmissionFees.vue"),
        },
        {
          path: "/admin/bursary/service-types",
          name: "serviceTypes",
          component: () => import("./components/bursary/ServiceTypes.vue"),
        },
        {
          path: "/admin/bursary/special-payments",
          name: "specialPayments",
          component: () => import("./components/bursary/SpecialPayments.vue"),
        },
        {
          path: "/admin/student/download",
          name: "studentDataDownload",
          component: () => import("./components/student/StudentDataDownload.vue"),
        },
        {
          path: "/admin/academics/colleges",
          name: "collegeManagement",
          component: () => import("./components/academics/CollegeManagement.vue"),
        },
        {
          path: "/admin/academics/departments",
          name: "departmentManagement",
          component: () => import("./components/academics/DepartmentManagement.vue"),
        },
        {
          path: "/admin/academics/programmes",
          name: "programmeManagement",
          component: () => import("./components/academics/ProgrammeManagement.vue"),
        },
        {
          path: "/admin/settings/sessions",
          name: "sessionSettings",
          component: () => import("./components/settings/SessionSettings.vue"),
        },
        {
          path: "/admin/settings/profile",
          name: "myProfile",
          component: () => import("./components/settings/MyProfile.vue"),
        },
        {
          path: "/admin/settings/staff",
          name: "staffManagement",
          component: () => import("./components/settings/StaffManagement.vue"),
        },
        {
          path: "/admin/settings/access-control",
          name: "accessControl",
          component: () => import("./components/settings/AccessControl.vue"),
        },
        {
          path: "/admin/settings/audit-log",
          name: "auditLog",
          component: () => import("./components/settings/AuditLog.vue"),
        },
        {
          path: "/admin/helpdesk",
          name: "helpdesk",
          component: () => import("./components/settings/Helpdesk.vue"),
        },
      ],
    },
    {
      path: "/home",
      name: "home",
      component: () => import("./components/Home"),
    },
    {
      path: "/document",
      name: "document",
      component: () => import("./components/Document"),
    },
    {
      path: "/account",
      name: "account",
      component: () => import("./components/Account"),
    },
    {
      path: "/settings",
      name: "settings",
      component: () => import("./components/Settings"),
    },
    {
      path: "/getapplication",
      name: "getapplication",
      component: () => import("./components/application/GetApplications"),
      props: true,
    },

    {
      path: "/notifications",
      name: "notifications",
      component: () => import("./components/Notification"),
    },

    {
      path: "*",
      name: "allhome",
      component: () => import("./components/Home"),
    },
  ],
});
